import React from "react"
import { Link } from "gatsby"
import Image from "../image"

import withAnalyticsContext from '../../lib/hocs/withAnalyticsContext';

class Top extends React.Component {

  applyClick = () => {
    this.props.analytics.logEvent('shop_apply_clicked', { button: '2' });
  }

  inquiryClick = () => {
    this.props.analytics.logEvent('shop_inquiry_clicked', { button: '2' });
  }

  render() {
    return (
      <div className="top">
        <div className="container is-slim">
          <div className="title-container">
            <h1 data-aos="fade-up" data-aos-delay="500" className="title is-2">
              モバイルオーダーで
              <br />
              テイクアウトの売上を最大化
            </h1>
            <div
              data-aos="fade-up"
              data-aos-delay="700"
              className="buttons-container-tablet columns"
            >
              <div className="button-container column">
                <a
                  className="button is-size-small-large is-primary is-fullwidth is-rounded"
                  href="https://start.picks.fun/apply"
                  onClick={this.applyClick}
                >
                  WEB申し込み
                </a>
              </div>
              <div className="button-container column">
                <a
                  className="button is-size-small-large is-primary is-fullwidth is-rounded is-outlined"
                  href="https://start.picks.fun/inquiry"
                  onClick={this.inquiryClick}
                >
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" className="screenshot-container">
            <Image filename="PicksforPartners/top-screenshot.png" />
          </div>
        </div>
        <div className="background" />
        <div
          data-aos="fade-up"
          data-aos-delay="700"
          className="buttons-container-mobile"
        >
          <div className="button-container">
            <a
              className="button is-size-small-large is-primary is-fullwidth is-rounded"
              href="https://start.picks.fun/apply"
              onClick={this.applyClick}
            >
              WEB申し込み
            </a>
          </div>
          <div className="button-container">
            <a
              className="button is-size-small-large is-primary is-fullwidth is-rounded is-outlined"
              href="https://start.picks.fun/inquiry"
              onClick={this.inquiryClick}
            >
              お問い合わせ
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default withAnalyticsContext(Top)
